import ReCAPTCHA from 'react-google-recaptcha';
import React, { useRef, FC } from 'react';
import { getSiteKey } from '$ind/hooks/useRecaptcha';

interface SigninRecaptchaProps {
  setReCaptchaResponse: (value: string) => void;
  recaptchaSiteKey?: string;
  lang?: string;
}

const SigninRecaptcha: FC<SigninRecaptchaProps> = ({
  setReCaptchaResponse,
  recaptchaSiteKey,
  lang = 'en',
}) => {
  const recaptchaRef = useRef<ReCAPTCHA | null>(null);

  const resetReCaptcha = () => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
  };

  const onReCaptchaChange = (value: string | null) => {
    if (value) {
      setReCaptchaResponse(value);
    } else {
      resetReCaptcha();
      setReCaptchaResponse('');
    }
  };

  const onReCaptchaExpired = () => {
    resetReCaptcha();
    setReCaptchaResponse('');
  };

  const onReCaptchaError = () => {
    resetReCaptcha();
    setReCaptchaResponse('');
  };

  const siteKey = recaptchaSiteKey || getSiteKey();

  return (
    <ReCAPTCHA
      ref={recaptchaRef}
      style={{ display: 'flex', justifyContent: 'center', width: '100%' }}
      sitekey={siteKey}
      onChange={onReCaptchaChange}
      onExpired={onReCaptchaExpired}
      onErrored={onReCaptchaError}
      hl={lang}
    />
  );
};

export default SigninRecaptcha;
